import { SideNavLink } from "@/libraries/design/components/side-nav/src/side-nav-link/src/side-nav-link";

export interface UniformSideNavLinkProps {
    type: "link";
    text: string;
    href: string;
}

const UniformSideNavLink = (props: UniformSideNavLinkProps) => {
    return (
        <SideNavLink
            {...props}
            dataEventProps={{
                "data-product-key": "uniform",
                "data-event-component": "linkButton",
                "data-event-container": "sideNav",
                "data-event": "clicked"
            }}
        />
    );
};

export default UniformSideNavLink;
